import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import img from '../../images/404.jpg'

const NotFound = () => {
    return (
        <div>
            {/*Adding cover image*/}
            <img className="w-50 mb-5" src={img} alt="" /><br />
            {/*Adding button to go back to homepage*/}
            <Link to="/home">
                <Button className="px-4 py-2 mx-auto my-5 fw-bold" variant="warning">Go Homepage</Button>
            </Link>
        </div>
    );
};

export default NotFound;